module.exports = "/img/view.svg?2015eeb4da0f58099c0a4a138807d98d";